import { ICustomer } from 'redux/reducers/customers';

/**
 * getBreakdownLabel gets the label for the current trends' breakdown or customerFilter
 * from the customers data. It assumes you are using the 'modern' customers endpoint.
 *
 * @param  breakdown The name or id of the current breakdown or filter
 * @param  customers  Customer metadata
 * @return  Customer display name
 */
function getBreakdownLabel(
  breakdown: string,
  customers: ICustomer[] | null
): string {
  if (!customers) return '';
  const nameOrId = typeof breakdown === 'string' ? 'name' : 'id';
  const customer = customers.find(
    (el: ICustomer) => el[nameOrId] === breakdown
  );
  return customer?.displayName ?? '';
}

export default getBreakdownLabel;
